import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  AmenitiesFilterCount,
  AmenitiesValue,
  AmenitiesFilterValue,
} from 'ha/types/SearchFilters';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: AmenitiesFilterValue;
  onChange: (value: AmenitiesFilterValue) => void;
  count?: AmenitiesFilterCount;
}

const AmenitiesFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      value={value}
      onChange={onChange}
      options={[
        {
          value: AmenitiesValue.DISHWASHER,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Dishwasher')}
              count={count?.dishwasher}
            />
          ),
          testLocator: 'Filter Dishwasher',
        },
        {
          value: AmenitiesValue.WASHING_MACHINE,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Washing machine')}
              count={count?.washingMachine}
            />
          ),
          testLocator: 'Filter Washing Machine',
        },
        {
          value: AmenitiesValue.DRYER,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Dryer')}
              count={count?.dryer}
            />
          ),
          testLocator: 'Filter Dryer',
        },
        {
          value: AmenitiesValue.AIR_CONDITIONING,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Air conditioning')}
              count={count?.airConditioning}
            />
          ),
          testLocator: 'Filter Air Condition',
        },
        {
          value: AmenitiesValue.HEATING,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Heating')}
              count={count?.heating}
            />
          ),
          testLocator: 'Filter Heating',
        },
      ]}
    />
  );
};

export default AmenitiesFilter;
